
import { useRoute } from 'vue-router'
import { defineComponent, reactive } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { PreviewService, DeployInfo } from './preview.service'
import { BrandConfig, logoDashboardHeaderSrc, useBrandCustomStore } from '@/services/brand-custom.service'
import { IS_PRIVATE } from '@/common/const/env'
import DeployPackageDownload from '@/views/dashboard/group/client-alive/_components/deploy-package-download/deploy-package-download.vue'

export default defineComponent({
  components: {
    DeployPackageDownload,
  },
  setup() {
    const route = useRoute()
    const params = route.query
    const injector = useReflectiveInjector([PreviewService])
    const previewService = injector.get(PreviewService)
    const data = reactive<DeployInfo>({
      systems: [] as string[],
      windows_download_url: '',
      win_server_download_url: '',
      windows_xp_download_url: '',
      windows_server2003_download_url: '',
      pin_code: '',
      team_name: '',
      linux_download_map: {},
      macos_download_url: '',
      macos_arm64_download_url: '',
      macos_amd64_download_url: ''
    })
    function getRegularDeploymentData() {
      previewService.fetchDeployInfo({ deploy_token: params.token as string }).then(res => {
        data.systems = Object.keys(res.linux_download_map)
        data.windows_download_url = res.windows_download_url
        data.macos_download_url = res.macos_download_url
        data.win_server_download_url = res.win_server_download_url
        data.windows_xp_download_url = res.windows_xp_download_url
        data.windows_server2003_download_url = res.windows_server2003_download_url
        data.pin_code = res.pin_code
        data.team_name = res.team_name
        data.linux_download_map = res.linux_download_map
        data.macos_arm64_download_url = res.macos_arm64_download_url
        data.macos_amd64_download_url = res.macos_amd64_download_url
      })
    }
    getRegularDeploymentData()

    return {
      IS_PRIVATE,
      brandConfig: useBrandCustomStore().brandConfig as BrandConfig,
      params,
      data,
      logoDashboardHeaderSrc
    }
  }
})
